<section class="our-mission-area ptb-100">
    <div class="container-fluid">
        <div class="row align-items-center">
            <div class="col-lg-6 col-md-12">
                <div class="our-mission-content">
                    <div class="content" *ngFor="let Content of ourMissionContent;">
                        <span class="sub-title"><img src="assets/img/star-icon.png" alt="image"> {{Content.subTitle}}</span>
                        <h2>{{Content.title}}</h2>
                        <p>{{Content.paragraphText1}}</p>
                        <ul class="our-mission-list">
                            <li *ngFor="let List of ourMissionList;">
                                <span>
                                    <div class="icon">
                                        <i class="{{List.icon}}"></i>
                                    </div>
                                    {{List.title}}
                                    <img src="assets/img/our-mission/shape2.png" alt="image">
                                </span>
                            </li>
                        </ul>
                        <p>{{Content.paragraphText2}}</p>
                        <a routerLink="/{{Content.defaultBtnLink}}" class="default-btn"><i class="{{Content.defaultBtnIcon}}"></i>{{Content.defaultBtnText}}<span></span></a>
                    </div>
                </div>
            </div>
            <div class="col-lg-6 col-md-12">
                <div class="our-mission-image" *ngFor="let Image of ourMissionImage;">
                    <img [src]="Image.img" alt="image">
                    <div class="shape"><img src="assets/img/our-mission/shape1.png"></div>
                </div>
            </div>
        </div>
    </div>
</section>